import TruncatedText from '@ben/orion/truncated-text';
import { flexRender, type Row } from '@tanstack/react-table';
import { StyledTableData, StyledTableRow } from '../../table.styles';

interface TableRowProps<T extends object> {
  row: Row<T>;
  onClick?: (row: Row<T>) => void;
}

export const TableRow = <T extends object>({
  row,
  onClick,
}: TableRowProps<T>) => {
  return (
    <StyledTableRow
      key={row.id}
      onClick={() => onClick?.(row)}
      $hasOnClick={!!onClick}
    >
      {row.getVisibleCells().map((cell) => {
        const {
          hug,
          align,
          truncate,
          manualTruncate,
          preventRowClick,
          fsMask,
        } = cell.column.columnDef.meta || {};

        const cellContent = flexRender(
          cell.column.columnDef.cell,
          cell.getContext()
        );

        return (
          <StyledTableData
            key={cell.id}
            className={fsMask ? 'fs-mask' : undefined}
            $textAlign={align}
            $maxWidth={truncate || manualTruncate ? 0 : undefined}
            $hug={hug}
            $isPinned={cell.column.getIsPinned()}
            onClick={
              preventRowClick ? (event) => event.stopPropagation() : undefined
            }
          >
            {truncate ? (
              <TruncatedText
                as="div"
                tooltipProps={{ wordBreak: 'break-word' }}
                tooltipText={cell.getValue() as string}
              >
                {cellContent}
              </TruncatedText>
            ) : (
              cellContent
            )}
          </StyledTableData>
        );
      })}
    </StyledTableRow>
  );
};
